const AplicationSubmit = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#23D400"
      />
      <path
        d="M35.25 15.0703C35.4531 15.2578 35.5625 15.4922 35.5781 15.7734C35.5938 15.8047 35.6016 15.8359 35.6016 15.8672C35.5547 16.1641 35.4766 16.3828 35.3672 16.5234L20.6953 35.3438C20.6172 35.4531 20.5078 35.5469 20.3672 35.625C20.2422 35.6875 20.1094 35.7266 19.9688 35.7422H19.8516C19.6953 35.7422 19.5469 35.7109 19.4062 35.6484C19.2656 35.5859 19.1406 35.4922 19.0312 35.3672L12.4922 27.6797C12.3359 27.4922 12.25 27.2812 12.2344 27.0469C12.2344 26.7969 12.3047 26.5703 12.4453 26.3672C12.5703 26.1797 12.75 26.0469 12.9844 25.9688C13.2188 25.8906 13.4531 25.8906 13.6875 25.9688L19.6406 28.1953L33.7969 15.0703C34 14.8984 34.2422 14.8125 34.5234 14.8125C34.8203 14.8125 35.0625 14.8984 35.25 15.0703Z"
        fill="white"
      />
    </svg>
  );
};

export default AplicationSubmit;
